"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { CalendarCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const neighborhoods = [{
  name: "Mixing & Mastering",
  path: "/ServicesPage"
}, {
  name: "Beat Licensing",
  path: "/ServicesPage"
}, {
  name: "Vocal Production",
  path: "/ServicesPage"
}, {
  name: "Sound Design",
  path: "/ServicesPage"
}, {
  name: "Custom Scoring",
  path: "/ServicesPage"
}, {
  name: "Studio Rental",
  path: "/ServicesPage"
}, {
  name: "Consultation",
  path: "/ServicesPage"
}];
export default function CommonInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="260732" id="common-inquiries" className="bg-background text-foreground flex flex-col">
      {}
      <div className="bg-muted/10 py-16 md:py-20 border-b border-border">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-default font-bold text-foreground mb-3 tracking-tighter">
            Explore Our Production Capabilities
          </h2>
          <p className="text-muted-foreground font-mono mb-10 text-base md:text-lg uppercase tracking-widest">
            Professional Sonic Solutions for Modern Artists
          </p>
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
            {neighborhoods.map((hood, i) => <Link key={i} to={hood.path} data-index={i} className="px-6 py-2.5 bg-background border border-border rounded-md text-sm font-mono font-medium text-foreground hover:bg-foreground hover:text-background transition-all shadow-sm hover:shadow-md">
                {hood.name}
              </Link>)}
          </div>
        </div>
      </div>

      {}
      <div className="py-16 md:py-24 bg-background">
        <div ref={ref} className={`container mx-auto px-4 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="bg-foreground text-background rounded-md p-8 md:p-14 text-center shadow-2xl flex flex-col items-center relative overflow-hidden">
            {}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-background/10 to-transparent pointer-events-none" />
            
            <div className="bg-background/10 p-4 rounded-md mb-8 relative z-10">
              <CalendarCheck className="w-8 h-8 text-background" />
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold mb-6 relative z-10 tracking-tighter">
              Start Your Next Sonic Project
            </h2>
            
            <p className="text-background/80 font-sans max-w-2xl mx-auto mb-10 text-lg leading-relaxed relative z-10">
              Ready to elevate your sound? Schedule a consultation with Rhythm & Soul Productions. We'll discuss your vision, review your demos, and outline a roadmap for your next release. No commitment required.
            </p>
            
            <Button size="lg" className="font-bold text-base px-8 h-14 rounded-md relative z-10 shadow-lg hover:bg-background hover:text-foreground transition-all border border-transparent hover:border-foreground">
              Book Studio Session
            </Button>
          </div>
        </div>
      </div>
    </section>;
}